import { Directive, Input, } from '@angular/core';
import { AbstractControl, AsyncValidator, NG_ASYNC_VALIDATORS, ValidationErrors } from '@angular/forms';
import { SharedDataService } from '../Services/shared-data/shared-data.service';
import { SuppliersService } from '../Services/suppliers.service';
import { Observable, of } from 'rxjs';
import {  map } from 'rxjs/operators';
import { SearchSuppliersParameters } from '../Models/SearchSuppliersParameters';
import { PS_Search_Suppliers_Result } from '../Models/PS_Search_Suppliers_Result';


@Directive({
  selector: '[siretUnique]',
  providers: [{
    provide: NG_ASYNC_VALIDATORS, useExisting: SiretUniqueDirective, multi:
      true
  }]
})
export class SiretUniqueDirective  implements AsyncValidator {

  constructor(private suppliersSvc:SuppliersService,private sharedDatasSvc:SharedDataService) { }
  @Input() siretUnique?:any = null;
  
  validate(control: AbstractControl): Promise<ValidationErrors> | Observable<ValidationErrors> {
    if ((control.value||'null')=='null') return of(null);
    let parameters : SearchSuppliersParameters = new SearchSuppliersParameters();
    parameters.UniqueId = (<string>control.value).replace(/\s/g, '');
    return this.suppliersSvc.getSuppliers(parameters)
    .pipe(map((result:PS_Search_Suppliers_Result[])=>{
      result = result.filter(r=>r.Id!=(<number>this.siretUnique||0));
      if (result && result.length>0) {
        return {'siretUnique': result[0]};        
      } else {
        return null;
      }
    }));
  }

  registerOnValidatorChange?(fn: () => void): void {
    
  }

}
